import { SUPPORTED_LANGUAGES } from '../config/supportedLanguages';

// Define the type for supported language codes
type SupportedLanguageCode = keyof typeof SUPPORTED_LANGUAGES;

/**
 * Extract the current language from the URL
 * Returns a valid language code or defaults to 'vi'
 */
export const getCurrentLanguageFromUrl = (): SupportedLanguageCode => {
  const pathSegments = window.location.pathname.split('/');
  const lang = pathSegments[1]; // Assuming the language is the first segment in the URL
  
  // Check if the language from URL is supported
  if (lang && Object.keys(SUPPORTED_LANGUAGES).includes(lang)) {
    return lang as SupportedLanguageCode;
  }
  
  // Check if there's a language in localStorage
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage && Object.keys(SUPPORTED_LANGUAGES).includes(savedLanguage)) {
    return savedLanguage as SupportedLanguageCode;
  }
  
  return 'vi'; // Default to 'vi' if no language is found
};

/**
 * Check if a language code is the currently active one
 */
export const isActiveLanguage = (langCode: SupportedLanguageCode | string): boolean => {
  return getCurrentLanguageFromUrl() === langCode;
};
